import { render, staticRenderFns } from "./RulesSelector.vue?vue&type=template&id=673e173f&scoped=true"
import script from "./RulesSelector.vue?vue&type=script&lang=ts"
export * from "./RulesSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e173f",
  null
  
)

export default component.exports